/** Shell común para pantallas /expenses-user (móvil ancho completo). */
export const expenseUserPageShellSx = (
  contentMargin,
  { maxWidth = 1000 } = {},
) => ({
  display: "flex",
  flexDirection: "column",
  minHeight: "100dvh",
  boxSizing: "border-box",
  overflow: "auto",
  width: "100%",
  maxWidth,
  minWidth: 0,
  pt: { xs: 1.25, md: 2 },
  px: { xs: 1.25, md: 3 },
  pb: { xs: 10, md: 2.5 },
  ...contentMargin,
  alignItems: "stretch",
});
